import React from "react";
import "../styles/FindUsSection.css";

function FindUsSection() {
    return (
        <section className="find-us-section">
            <div className="find-us-container">
                <div className="find-us-info">
                    <h2 className="find-us-title">Visit Us</h2>
                    <p className="find-us-description">
                        Sol Cafe & Lounge invites you to an unforgettable experience in the heart of the city.
                        Indulge in culinary delights and captivating ambiance while enjoying our premium
                        services. Find us at:
                    </p>
                    <address className="find-us-address">
                        8206 Bayview Ave, Thornhill, ON L3T 2S2
                        <br/>
                        <br/>
                        <strong>Hours:</strong>
                        <br/>Tue - Thu: 6pm - 12am
                        <br/>Fri - Sat: 8:30pm - 2am
                        <br/>Sun: 6pm - 12am
                        <br/>
                        <br/>
                        <strong>Phone:</strong> +1 (647) 505-9020
                    </address>

                    {/* Updated button to a functional link */}
                    <a
                        href="https://www.google.com/maps/dir/?api=1&destination=8206+Bayview+Ave,+Thornhill,+ON+L3T+2S2"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="find-us-button"
                    >
                        Get Directions
                    </a>
                </div>
                <div className="find-us-map">
                    <iframe
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2878.1458908421746!2d-79.40814342328589!3d43.83207287109418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2bdb9665344b%3A0xe5d2e8d748d80fcb!2sSOL%20Cafe%20%26%20Lounge!5e0!3m2!1sen!2sca!4v1736383910720!5m2!1sen!2sca"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </div>
        </section>
    );
}

export default FindUsSection;
